import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: () => {
        window.location.href = 'https://app.thewave.com/surfers/sign-waivers';
      }
    },
    {
      path: '/terms',
      name: 'user-waiver-terms',
      redirect: () => {
        window.location.href = 'https://app.thewave.com/surfers/sign-waivers';
      }
    },
    {
      path: '/accept',
      name: 'user-waiver-accept',
      redirect: () => {
        window.location.href = 'https://app.thewave.com/surfers/sign-waivers';
      }
    },
    {
      path: '/thanks',
      name: 'thanks',
      redirect: () => {
        window.location.href = 'https://app.thewave.com/surfers/sign-waivers';
      }
    }
    ,
    {
      path: '/scan',
      name: 'scan',
      redirect: () => {
        window.location.href = 'https://app.thewave.com/surfers/sign-waivers';
      }
    }
  ]
})
